var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"set_dia",attrs:{"close-on-click-modal":false,"visible":_vm.visible,"width":"72%","append-to-body":true},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('iframe',{staticClass:"set_ifra",staticStyle:{"width":"70vw","height":"94vh"},attrs:{"src":_vm.tUrl,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }